import { render } from "./PageBuilder.vue?vue&type=template&id=a4f8f1c2"
import script from "./PageBuilder.vue?vue&type=script&lang=js"
export * from "./PageBuilder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__